exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chart-container[data-v-e2710dec] {\n  padding: 0 10px;\n}", ""]);

// exports
